<template>
  <div class="resources-and-support section-container">
    <header-title-two title="Go-To Resources & Support" />
    <skeleton-card-list
      class="mt-3"
      type="avatar"
      :isCard="true"
      direction="horizontal"
    >
      <div class="resources">
        <div
          v-for="item in resources"
          v-bind:key="item.id"
          class="resources-item"
        >
          <card-one
            :title="item.title"
            :description="item.description"
            :icon="item.icon"
            :url="item.url"
            :buttonText="item.buttonText"
          />
        </div>
      </div>
    </skeleton-card-list>
  </div>
</template>

<script>
import HeaderTitleTwo from '../../components/typography/header-title-2.vue';
import CardOne from '../../components/cards/card-1.vue';
import SkeletonCardList from '../../components/skeleton/CardList.vue';

export default {
  components: {
    HeaderTitleTwo,
    CardOne,
    SkeletonCardList,
  },
  data: () => {
    return {
      resources: [
        {
          id: 1,
          title: 'Glossary',
          description:
            'Green Street’s definitions for key commercial real estate terms.',
          icon: 'book.svg',
          url: '/glossary',
        },
        {
          id: 2,
          title: 'FAQs',
          description:
            'Frequently asked questions about our platform and products.',
          icon: 'bulb.svg',
          url: '/faq',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.resources {
  display: flex;
  flex-direction: row;
  margin: 16px 0 0;
  width: 100%;
  gap: 16px;

  @media (max-width: 1263px) {
    margin-bottom: 32px;
  }
  &-item {
    flex: 1;
    min-width: 0;
  }
}
</style>
